import React from 'react';

const AddCircleBgBlueIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" fill="#3772FF" />
      <path d="M8 12H16" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 16V8" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default AddCircleBgBlueIcon;
